module.exports = __webpack_public_path__ + "static/img/backImg.fe25480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/backImg.png
// module id = 8I4A
// module chunks = 1